<template>
    <ClientOnly>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 181 181"
            fill="none"
            v-bind="$attrs"
            width="181"
            height="181">
            <g opacity="0.5">
                <g :filter="`url(#filter0_i_1073_15615_${timestamp})`">
                    <path
                        d="M65.7 180.834L62.1 152.034C60.15 151.284 58.3125 150.384 56.5875 149.334C54.8625 148.284 53.175 147.159 51.525 145.959L24.75 157.209L0 114.459L23.175 96.909C23.025 95.859 22.95 94.8465 22.95 93.8715V87.7965C22.95 86.8215 23.025 85.809 23.175 84.759L0 67.209L24.75 24.459L51.525 35.709C53.175 34.509 54.9 33.384 56.7 32.334C58.5 31.284 60.3 30.384 62.1 29.634L65.7 0.833984H115.2L118.8 29.634C120.75 30.384 122.588 31.284 124.312 32.334C126.037 33.384 127.725 34.509 129.375 35.709L156.15 24.459L180.9 67.209L157.725 84.759C157.875 85.809 157.95 86.8215 157.95 87.7965V93.8715C157.95 94.8465 157.8 95.859 157.5 96.909L180.675 114.459L155.925 157.209L129.375 145.959C127.725 147.159 126 148.284 124.2 149.334C122.4 150.384 120.6 151.284 118.8 152.034L115.2 180.834H65.7Z"
                        :fill="`url(#paint0_linear_1073_15615_${timestamp})`" />
                </g>
                <path
                    d="M62.5961 151.972L62.559 151.675L62.2795 151.567C60.3565 150.828 58.546 149.941 56.8475 148.907C55.1343 147.864 53.4581 146.747 51.8191 145.555L51.5911 145.389L51.3313 145.498L24.9622 156.577L0.654092 114.591L23.4769 97.3076L23.7116 97.1298L23.67 96.8383C23.523 95.8097 23.45 94.8209 23.45 93.8715V87.7965C23.45 86.8471 23.523 85.8583 23.67 84.8297L23.7116 84.5382L23.4769 84.3604L0.654092 67.0771L24.9622 25.0905L51.3313 36.1699L51.5912 36.2791L51.8191 36.1134C53.4552 34.9234 55.1661 33.8076 56.9519 32.7659C58.734 31.7263 60.5142 30.8364 62.2923 30.0955L62.5602 29.9839L62.5961 29.696L66.1414 1.33398H114.759L118.304 29.696L118.341 29.9932L118.621 30.1007C120.544 30.8403 122.354 31.7272 124.053 32.7611C125.766 33.8039 127.442 34.9213 129.081 36.1134L129.309 36.2791L129.569 36.1699L155.938 25.0905L180.246 67.0771L157.423 84.3604L157.188 84.5382L157.23 84.8297C157.377 85.8583 157.45 86.8471 157.45 87.7965V93.8715C157.45 94.7948 157.308 95.761 157.019 96.7716L156.925 97.1009L157.198 97.3076L180.021 114.591L155.714 156.576L129.57 145.499L129.31 145.388L129.081 145.555C127.445 146.745 125.734 147.86 123.948 148.902C122.166 149.942 120.386 150.832 118.608 151.572L118.34 151.684L118.304 151.972L114.759 180.334H66.1414L62.5961 151.972Z"
                    stroke="white" />
            </g>
            <defs>
                <filter
                    :id="`filter0_i_1073_15615_${timestamp}`"
                    x="0"
                    y="0.833984"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                    width="180.9"
                    height="180">
                    <feFlood
                        flood-opacity="0"
                        result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="9" />
                    <feComposite
                        in2="hardAlpha"
                        operator="arithmetic"
                        k2="-1"
                        k3="1" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                    <feBlend
                        mode="normal"
                        in2="shape"
                        :result="`effect1_innerShadow_1073_15615_${timestamp}`" />
                </filter>
                <linearGradient
                    :id="`paint0_linear_1073_15615_${timestamp}`"
                    x1="90.45"
                    y1="0.833984"
                    x2="90.45"
                    y2="180.834"
                    gradientUnits="userSpaceOnUse">
                    <stop stop-color="white" />
                    <stop
                        offset="1"
                        stop-color="white"
                        stop-opacity="0" />
                </linearGradient>
            </defs>
        </svg>
    </ClientOnly>
</template>

<script setup lang="ts">
const timestamp = Date.now() + getRandomNumber(1, 500)
</script>
